import PatternFieldValidator from './PatternFieldValidator'
import PhoneNumberFieldValidator from './PhoneNumberFieldValidator'
import jQuery from 'jquery'

export default class FormValidator {

  constructor(form) {
    const onChange = this.onChange.bind(this),
      validate = this.validate.bind(this)

    this.patternValidator = new PatternFieldValidator()
    this.phoneValidator = new PhoneNumberFieldValidator()
    this.form = form

    this.validateField = this.validateField.bind(this)

    form.addEventListener('keyup', e => {
      onChange(e, false)
    })
    form.addEventListener('focusout', e => {
      onChange(e, true)
    })
    form.addEventListener('submit', e => {
      e.preventDefault()
      if (!validate(form)) {
        e.stopImmediatePropagation()
        e.stopPropagation()
      }
    })
  }

  validateField(input) {
    if (!input || !input.name) {
      return true
    }

    const type = input.getAttribute('type'),
      isPhone = type === 'tel',
      validator = isPhone ? this.phoneValidator : this.patternValidator,
      fieldContainer = jQuery(input).parents('.field-container'),
      isValid = validator.validate(input)

    if (isValid) {
      fieldContainer.removeClass('error')

    } else {
      fieldContainer.addClass('error')
    }

    return isValid
  }

  validate(form) {
    const fields = form.querySelectorAll('[required],[pattern]'),
      validateField = this.validateField

    let isValid = true
    fields.forEach(field => {
      isValid = isValid && validateField(field)
    })
    return isValid
  }

  onChange(event, isBlur) {
    const input = event.target,
      jInput = jQuery(input)

    if (isBlur) {
      const focusAttrName = 'focus-by-js'
      if (jInput.is('[' + focusAttrName + ']')) {
        input.removeAttribute(focusAttrName)
        return
      }

    } else { // Keypress
      const form = input.form

      if (form && window.Event) {
        let event
        if (window.Event) {
          event = new Event('change')

        } else if (document.createEvent) {
          event = document.createEvent('Event')
          event.initEvent('change', false, true);
        }

        if (event) {
          form.dispatchEvent(event)
        }
      }

      const hasError = jInput.parents('.field-container.error').length

      if (!hasError) {
        return;
      }
    }

    this.validateField(input)
  }

}